import HeroSection from '../../components/home_page/hero_section/hero_section';
import ExploreSection from '../../components/home_page/explore_section/explor_section';

function Home() {
  return (
    <>
      <HeroSection />
      <ExploreSection />
    </>
  );
}

export default Home;